// extracted by mini-css-extract-plugin
export default {"wrapper":"PdxOMtax8cF_qTCdfUoQ","icon":"ZVKlaQnjG7OguCaC7MyD"};